export default "__VITE_ASSET__E$VUsFvC__"